/**
 * SitePick front — セール終了までの残り時間（カウントダウン）。
 *
 * サーバーが描いた `.js-sp-sale-deadline[data-sp-sale-ends][data-sp-now]` の残り時間を埋めるだけ。
 * 価格・割引の判定はしない（終了後の価格はサーバーが次の表示で通常価格に戻す）。
 * 端末の時計のずれは、描画時のサーバー時刻（data-sp-now）との差で補正する。
 * JS が動かなくても「○月○日（○）○:○○まで」は読める（残り時間だけが出ない）。
 */

const pad = (n) => String(n).padStart(2, "0");

/**
 * @param {number} seconds 残り秒数（0 以上）。
 * @returns {string}
 */
function remainingText(seconds) {
  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const hms = `${pad(h)}:${pad(m)}:${pad(s)}`;
  return d > 0 ? `あと ${d}日 ${hms}` : `あと ${hms}`;
}

export function initSaleCountdown(root = document) {
  const nodes = [...root.querySelectorAll(".js-sp-sale-deadline")];
  if (!nodes.length) {
    return;
  }
  const items = nodes
    .map((el) => {
      const ends = Number(el.dataset.spSaleEnds);
      const serverNow = Number(el.dataset.spNow);
      const out = el.querySelector(".js-sp-sale-remaining");
      if (!Number.isFinite(ends) || !Number.isFinite(serverNow) || !out) {
        return null;
      }
      // サーバー時刻 − 端末時刻（秒）。以後は端末の経過時間で進める。
      const offset = serverNow - Date.now() / 1000;
      return { el, out, ends, offset };
    })
    .filter(Boolean);
  if (!items.length) {
    return;
  }

  let timer = 0;
  const tick = () => {
    let alive = 0;
    for (const item of items) {
      const left = Math.max(0, Math.floor(item.ends - (Date.now() / 1000 + item.offset)));
      if (left > 0) {
        item.out.textContent = remainingText(left);
        alive += 1;
      } else if (!item.el.classList.contains("is-ended")) {
        item.el.classList.add("is-ended");
        item.out.textContent = "セールは終了しました";
      }
    }
    if (!alive) {
      window.clearInterval(timer);
    }
  };
  tick();
  timer = window.setInterval(tick, 1000);
}
